<template>
  <div class="navbar f fc fbt">
    <div class="left f fc">
      <el-icon size="20" class="nav-icon" @click="store.setSystemSetting('hideMenu')">
        <Expand v-if="systemSetting.hideMenu" />
        <Fold v-else />
      </el-icon>
      <div class="welcome-text">{{ $t('歡迎使用') }}，{{ userName }}</div>
    </div>
    <div class="right f fc">
      <el-tooltip :content="systemSetting.darkMode ? $t('切換淺色') : $t('切換深色')" placement="bottom">
        <el-icon size="20" class="nav-icon theme-toggle" @click="store.setSystemSetting('darkMode')">
          <Sunny v-if="systemSetting.darkMode" />
          <Moon v-else />
        </el-icon>
      </el-tooltip>
      <el-dropdown trigger="click" class="language-switcher" @command="handleLanguageChange">
        <el-button text class="lang-btn">
          <svg viewBox="0 0 24 24" width="1.2em" height="1.2em">
            <path
              fill="currentColor"
              d="m18.5 10l4.4 11h-2.155l-1.201-3h-4.09l-1.199 3h-2.154L16.5 10h2zM10 2v2h6v2h-1.968a18.222 18.222 0 0 1-3.62 6.301a14.864 14.864 0 0 0 2.336 1.707l-.751 1.878A17.015 17.015 0 0 1 9 13.725a16.676 16.676 0 0 1-6.201 3.548l-.536-1.929a14.7 14.7 0 0 0 5.327-3.042A18.078 18.078 0 0 1 4.767 8h2.24A16.032 16.032 0 0 0 9 10.877a16.165 16.165 0 0 0 2.91-4.876L2 6V4h6V2h2zm7.5 10.885L16.253 16h2.492L17.5 12.885z"
            />
          </svg>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              v-for="item in languageOptions"
              :key="item.value"
              :command="item.value"
              :class="{ 'is-active': currentLanguage === item.value }"
            >
              {{ $t(item.label) }}
              <el-tooltip
                v-if="item.value === 'en'"
                :content="
                  $t('英语为谷歌翻译，可能存在翻译不准确的情况，如有问题请咨询管理员调整翻译')
                "
              >
                <el-icon class="lang-info-icon">
                  <InfoFilled />
                </el-icon>
              </el-tooltip>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <div class="btn" @click="logout">{{ $t('登出') }}</div>
    </div>
  </div>
</template>

<script setup>
import { rootStore } from '@/store/rootStore';
import { storeToRefs } from 'pinia';
import { Expand, Fold, Moon, Sunny, InfoFilled } from '@element-plus/icons-vue';
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { logout } from '@/lib/auth';
import { getStore } from '@/lib/localStore';
import { languageOptions, setLanguage } from '@/i18n';

const store = rootStore();
const { userName, systemSetting } = storeToRefs(store);

const { locale } = useI18n();
const currentLanguage = computed(() => locale.value);

function handleLanguageChange(lang) {
  setLanguage(lang);
}

const getSetting = () => {
  const settingInfo = getStore({ name: 'systemSetting' });
  if (settingInfo === null) return;

  if (settingInfo.hideMenu !== undefined) {
    store.setSystemSetting('hideMenu', settingInfo.hideMenu);
  }
  if (settingInfo.darkMode !== undefined) {
    store.setSystemSetting('darkMode', settingInfo.darkMode);
  }
};

onMounted(() => {
  getSetting();
});
</script>

<style lang="less" scoped>
.navbar {
  height: 50px;
  box-sizing: border-box;
  font-size: 14px;
  color: var(--navbar-text);

  .nav-icon {
    margin-right: 10px;
    cursor: pointer;
    color: var(--navbar-text);
    transition: color 0.2s;

    &:hover {
      color: var(--brand);
    }
  }

  .theme-toggle {
    margin-right: 4px;
  }

  .welcome-text {
    color: var(--navbar-text);
  }

  .lang-btn {
    color: var(--navbar-text);
    padding: 4px 8px;
    margin-right: 4px;
  }

  .lang-info-icon {
    margin-left: 4px;
    vertical-align: middle;
  }

  .btn {
    margin-left: 20px;
    cursor: pointer;
    color: var(--navbar-text);
    transition: color 0.2s;

    &:hover {
      color: var(--brand);
    }
  }
}
</style>

<style lang="less">
.el-dropdown-menu__item {
  &.is-active {
    color: #409eff;
  }
}
</style>
